/*
 * @Author: DWP
 * @Date: 2020-07-21 16:25:45
 * @LastEditors: Dong
 * @LastEditTime: 2022-06-01 15:44:14
 */
import React, { Component } from 'react';
import { Resizable } from 'react-resizable';

class CustomHeaderCell extends Component {
  startResize = () => {
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';
  }

  stopResize = () => {
    document.body.style.userSelect = '';
    document.body.style.cursor = '';
  }

  // 拖拽阻止冒泡
  handleClick = (e) => {
    if (e) {
      e.stopPropagation();
    }
  }

  render() {
    const { children, onResize, resize, width, size, type,theadStyle = {}, ...resProps } = this.props;

    const style={...resProps.style, ...theadStyle};

    const thDom = (
      <th {...resProps} style={style}>
        { children }
      </th>
    );

    // 操作列不允许拖拽
    if (!width || !resize || type === 'operation') {
      return thDom;
    }

    return (
      <Resizable
        width={width}
        height={0}
        minConstraints={[50, 50]}
        handle={<span className="react-resizable-handle react-resizable-handle-se" onClick={this.handleClick} />}
        onResizeStart={this.startResize}
        onResizeStop={this.stopResize}
        onResize={onResize}
        draggableOpts={{ enableUserSelectHack: false }}
      >
        {thDom}
      </Resizable>
    );
  }
}

export default CustomHeaderCell;
